import {
	ResellerServiceInterface,
	Reseller,
	ResellerFormValues,
	APIClientInterface,
	SingleResponse,
	ListResponse,
	EndCustomer,
	ReportEntry,
	ReportType,
	ResellerLicense,
	ResellerLicenseLimitWarning
} from '../types'

export default class ResellerService implements ResellerServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async getById(id: number): Promise<SingleResponse<Reseller>> {
		return this.client.get(`/resellers/${id}`)
	}

	public async getAll(): Promise<ListResponse<Reseller>> {
		return this.client.get(`/resellers`)
	}

	public async getChildren(id: number): Promise<SingleResponse<EndCustomer[]>> {
		return this.client.get(`/resellers/${id}/endcustomers`)
	}

	public async delete(id: number): Promise<void> {
		return this.client.delete(`/resellers/${id}`)
	}

	public async edit(id: number, values: ResellerFormValues): Promise<SingleResponse<Reseller>> {
		return this.client.patch(`/resellers/${id}`, JSON.stringify(values))
	}

	public async create(values: ResellerFormValues): Promise<SingleResponse<Reseller>> {
		return this.client.post(`/resellers`, JSON.stringify(values))
	}

	public async getReport(id: number): Promise<SingleResponse<ReportEntry>> {
		return this.client.get(`/resellers/${id}/report`)
	}

	public async getCsvReport(id: number, type: ReportType): Promise<SingleResponse<string>> {
		return this.client.get(`/resellers/${id}/report/csv/${type}`)
	}

	public async getLicenses(id: number): Promise<SingleResponse<Record<string, ResellerLicense>>> {
		return this.client.get(`/resellers/${id}/licenses`)
	}

	public async updateLicense(id: number, type: string, values: Partial<ResellerLicense>): Promise<void> {
		return this.client.patch(`/resellers/${id}/licenses/${type}`, JSON.stringify(values))
	}

	public async getLicensesNearLimit(id: number): Promise<SingleResponse<Record<string, ResellerLicenseLimitWarning>>> {
		return this.client.get(`/resellers/${id}/licenses/near-limit`)
	}
}
